import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-status-bubble',
    templateUrl: './status-bubble.component.html',
    styleUrls: ['./status-bubble.component.scss'],
    standalone: false
})
export class StatusBubbleComponent {
  @Input() status: string | undefined = '';
  @Input() statusDescription:string|null=null;
  statusClass: string = '';
  statusName: string = '';

  ngOnInit(): void {
    if (this.status == undefined)
      return;
    
    this.statusClass = this.status.replace(/\s+/g, '').toLocaleLowerCase();
   
    switch(this.statusDescription)
    {
      case null:
        this.statusName = this.status;
        break;
      default:
        this.statusName = this.statusDescription
        break;
    }
    
  }
}
